import { Navigate } from 'react-router-dom';
import { clearAuthSession, dispatchStorageSync } from '../services/sessionStorage';

interface ProtectedRouteProps {
  element: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element }) => {
  const token = localStorage.getItem('authToken');
  
  // Check if token exists and not empty
  if (!token || token.trim() === '') {
    // Clear invalid token
    clearAuthSession();
    dispatchStorageSync();
    return <Navigate to="/login" replace />;
  }

  // Token exists, allow access
  // If token is invalid, Request interceptor will handle 401 and redirect to login
  return <>{element}</>;
};

export default ProtectedRoute;
